import styled from 'styled-components';
import { breakpoints } from 'themes/helpers';

export const LogoWrapper = styled.div`
  padding: 16px 11px 12px 16px;

  @media (min-width: ${() => breakpoints.tablet}px) {
    padding: 0;
  }
`;
